import { PRIVACY_URL, TERMS_URL } from "constants/legal";

const LINK_CLASSES = "hover:underline";

/** Links to After's privacy policy and terms, opening on after.com. Shared by
 * the sign-in pages and the portal sidebar; the caller sets layout and type
 * through `className`. */
export default function LegalLinks({ className }: { className?: string }) {
  return (
    <div className={className}>
      <a
        href={PRIVACY_URL}
        target="_blank"
        rel="noopener noreferrer"
        className={LINK_CLASSES}
      >
        Privacy
      </a>
      <a
        href={TERMS_URL}
        target="_blank"
        rel="noopener noreferrer"
        className={LINK_CLASSES}
      >
        Terms
      </a>
    </div>
  );
}
